const paginationScroll = (offset = 20) => {
  const mainWrapper = document.querySelector('.js-related-posts-wrapper');
  if (mainWrapper) {
    const position = mainWrapper?.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const top = scrollTop + position.top - offset;
    window.scroll({
      top,
      behavior: 'smooth',
    });
  }
};

export default paginationScroll;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/pagination-scroll.js